import { createFileRoute } from '@tanstack/react-router';

import { DataSyncLogResult } from '~/modules/dataSyncJobs/logs/DataSyncLogResult';
import { LoadingPage } from '~/modules/router/components';

import { buildRouteExport } from '~/utils/buildRouteExport';
import { createProtectedRoute } from '~/utils/routeProtection';

export const Route = createFileRoute(
  '/(main)/settings/admin/data-sync/logs/$logId/',
)({
  beforeLoad: createProtectedRoute({
    routePath: '/settings/admin/data-sync/logs/$logId',
  }),
  component: DataSyncLogResult,
  pendingComponent: LoadingPage,
  wrapInSuspense: true,
});

export const DATA_SYNC_LOG_RESULT = buildRouteExport({
  Route,
});
